import { render } from "./RectangleIcon.vue?vue&type=template&id=43686ddf"
import script from "./RectangleIcon.vue?vue&type=script&lang=js"
export * from "./RectangleIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__